<template>
    <div class="card shadow-sm mb-4" id="propertySupplyDetails">
        <div class="card-body py-5 px-4">
            <div class="d-flex flex-row align-items-start ">
                <img src="../../assets/images/setup/truck.svg" alt="" class="mr-3" style="width: 29px">
                <h3>Property and Energy supply details</h3>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <p class="mb-1">Select property</p>
                        <div class="custom-control custom-radio" v-for="(property, key) in properties" :key="key">
                            <input type="radio" :id="'customRadio'+key" name="customRadio" class="custom-control-input"  v-model="selectedProperty" :value="property.id">
                            <label class="custom-control-label pb-3 pb-lg-0" :for="'customRadio'+key" >{{property.currentPropertyAddress}}</label>
                        </div>
                    </div>
                    <a href="#" @click.prevent="$refs.addModal.show" class="float-right ">+ Add another property</a>
                </div>
            </div>
            <fade-transition>
                <div v-if="!loading">
                <slide-y-up-transition>
                <choice-wrap col-class="col-12  border-bottom py-4" v-if="selectedPropertyDetails">
                    <template v-slot:title>
                        <img src="../../assets/images/setup/bed.svg" alt="" class="mr-3">
                        <h3>Property Type:</h3>
                    </template>
                    <choice v-model="selected.currentPropertyType" :errors.sync="errors.currentPropertyType" :data="data.currentPropertyType" :show-buttons="false" :show-select-control="true" select-placeholder="Please select" />
                </choice-wrap>
                </slide-y-up-transition>
                <slide-y-up-transition>
                <choice-wrap col-class="col-12  border-bottom py-4" v-if="selectedPropertyDetails">
                    <template v-slot:title>
                        <img src="../../assets/images/setup/bed.svg" alt="" class="mr-3">
                        <h3>How large is your property</h3>
                    </template>
                    <choice v-model="selected.currentPropertySize" :errors.sync="errors.currentPropertySize" :data="data.currentPropertySize" :show-button-title="true"/>
                </choice-wrap>
                </slide-y-up-transition>
                <slide-y-up-transition>
                <choice-wrap col-class="col-12  border-bottom py-4 pb-0" v-if="selectedPropertyDetails">
                    <template v-slot:title>
                        <img src="../../assets/images/setup/property.svg" alt="" class="mr-3">
                        <h3>Do you rent or own your home?</h3>
                    </template>
                    <choice v-model="selected.currentPropertyOwnership" :errors.sync="errors.currentPropertyOwnership" :data="data.currentPropertyOwnership" :show-button-title="true"/>
                </choice-wrap>
                </slide-y-up-transition>
                <slide-y-up-transition>
                    <div class="row border-bottom" v-if="propertyDetailsChanged">
                        <div class="col my-4">
                            <button class="btn btn-success btn-lg btn-success-gradient px-5 float-right" @click="updatePropertyDetails">Update Property Details</button>
                        </div>
                    </div>
                </slide-y-up-transition>
        
                <slide-y-up-transition>
                    <choice-wrap col-class="col-12  py-4 border-bottom" v-if="selectedPropertyDetails && dualTariff" choice-col-class="col-12 col-lg-12">
                        <template v-slot:title>
                            <img src="../../assets/images/setup/meter.svg" alt="" class="mr-3">
                            <h3>Energy supply</h3>
                        </template>
                        <deal-summary :deal="dualTariff" />
                        <h4 class="text-center my-4">Your Tariff Summary:</h4>
                        <deal-tariff-summary :deal="dualTariff" type="D" />
                    </choice-wrap>
                </slide-y-up-transition>
                <slide-y-up-transition>
                    <choice-wrap col-class="col-12  py-4 border-bottom" v-if="selectedPropertyDetails && electricityTariff" choice-col-class="col-12 col-lg-12">
                        <template v-slot:title>
                            <img src="../../assets/images/setup/meter.svg" alt="" class="mr-3">
                            <h3>Electricity supply</h3>
                        </template>
                        <deal-summary :deal="electricityTariff" />
                        <h4 class="text-center my-4">Your Tariff Summary:</h4>
                        <deal-tariff-summary :deal="electricityTariff" type="E" />
                    </choice-wrap>
                </slide-y-up-transition>
                <slide-y-up-transition>
                    <choice-wrap col-class="col-12  py-4 border-bottom" v-if="selectedPropertyDetails && gasTariff" choice-col-class="col-12 col-lg-12">
                        <template v-slot:title>
                            <img src="../../assets/images/setup/meter.svg" alt="" class="mr-3">
                            <h3>Gas supply</h3>
                        </template>
                        <deal-summary :deal="gasTariff" />
                        <h4 class="text-center my-4">Your Tariff Summary:</h4>
                        <deal-tariff-summary :deal="gasTariff" type="G" />
                    </choice-wrap>
                </slide-y-up-transition>
                <slide-y-up-transition>
                <div class="row" v-if="selectedPropertyDetails && (!selectedPropertyDetails.recommendation || (selectedPropertyDetails.recommendation && selectedPropertyDetails.recommendation.editable))">
                    <div class="col-8 mx-auto">
                        <h3 class="text-center mt-5">
                            Is the above information correct?
                        </h3>
                        <div class="row">
                            <div class="col-12  my-5">
                                <p>
                                    If you are currently on a different tariff or supplier, please update your current
                                    energy supply information. We’ll then compare the market and make sure that you get on
                                    the best tariff for you.
                                </p>
                            </div>
                        </div>
                        <div class="row"  >
                            <div class="col-12 col-lg-5 mx-auto">
                                <router-link :to="{ name: 'PropertySupplyUpdate', params: {property: selectedPropertyDetails.id } }" class="btn btn-success btn-success-gradient btn-lg btn-block">
                                    Update my supply details
                                </router-link>
                                <router-link :to="{ name: 'PropertyUsageUpdate', params: {property: selectedPropertyDetails.id } }" class="btn btn-success btn-success-gradient btn-lg btn-block">
                                    Update my usage details
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                </slide-y-up-transition>
                </div>
            </fade-transition>
        </div>
    
        <address-modal  ref="addModal"  @selected="onAddressChange" />
    </div>
</template>
<script>
import {mapGetters} from "vuex";
import {each} from "lodash"
import {FadeTransition, SlideYUpTransition} from 'vue2-transitions'
import Choice from "@/components/setup/Choice"
import ChoiceWrap from "@/components/setup/ChoiceWrap"
import AddressModal from "@/components/setup/AddressModal";
import api from "@/utils/api";
import ClearStoreMixin from "@/mixins/ClearStoreMixin";
import DealSummary from "@/components/setup/DealSummary";
import DealTariffSummary from "@/components/setup/DealTariffSummary";

export default {
    name: 'PropertyDetails',
    components: {DealTariffSummary, DealSummary, Choice, ChoiceWrap, AddressModal,SlideYUpTransition, FadeTransition},
    mixins:[ClearStoreMixin],
    data() {
        return {
            properties: [],
            selectedProperty: null,
            selectedPropertyDetails: null,
            dualTariff: null,
            electricityTariff: null,
            gasTariff: null,
            selected: {
                currentPropertySize: null,
                currentPropertyOwnership: null,
                currentPropertyType: null,
            },
            errors: {
                currentPropertySize: [],
                currentPropertyOwnership: [],
                currentPropertyType: [],
            },
            loading: false,
        }
    },
    computed: {
        ...mapGetters('setup', {
            data: 'stepOneData'
        }),
        propertyDetailsChanged: function () {
            return this.selectedPropertyDetails && (this.selectedPropertyDetails.currentPropertySize !== this.selected.currentPropertySize ||
                this.selectedPropertyDetails.currentPropertyOwnership !== this.selected.currentPropertyOwnership ||
                this.selectedPropertyDetails.currentPropertyType !== this.selected.currentPropertyType)
        }
    },
    methods: {
        onAddressChange: function (address) {
            this.clearStore()
            this.$store.commit('setup/setAddress', address);
            this.$router.push({name: 'SetupHome' });
        },
        validate: function (){
            if(!this.selected.currentPropertySize){
                this.errors.currentPropertySize.push("Please select your property size!")
            }
            if(!this.selected.currentPropertyOwnership){
                this.errors.currentPropertyOwnership.push("Please select if you rent or own your home!")
            }
            if(!this.selected.currentPropertyType){
                this.errors.currentPropertyType.push("Please select your property type!")
            }
        },
        updatePropertyDetails: function (){
            let that = this;
            this.validate()
    
            let length = Object.values(this.errors).filter(v => !!v.length).length;
            if(length){
                return
            }
            api.updateProperty(this.selectedPropertyDetails.id, this.selected).then(() => {
                that.$toast.success('Property updated successfully!')
                each(that.selected, function (value, key){
                    that.selectedPropertyDetails[key] = value
                });
            }).catch(() => {
                that.$toast.error('Problem with updating property details!')
            })
        }
    },
    watch: {
        selectedProperty: function (newValue) {
            this.loading = true;
            let that = this;
            if(!newValue){
                that.selectedPropertyDetails = null;
                
                this.selected = {
                    currentPropertySize: null,
                    currentPropertyOwnership: null,
                    currentPropertyType: null,
                }
                this.loading = false;
                return;
            }
            
            api.property(newValue).then(response => {
                that.selectedPropertyDetails = response.data.data;
                each(that.selected, function (value, key){
                    that.selected[key] = response.data.data[key]
                });
                this.loading = false;
                if(this.$route.query.property){
                    this.$nextTick(function (){
                        let elm = window.document.getElementById('propertySupplyDetails')
                        if(elm){
                            elm.scrollIntoView()
                        }
                    })
                }
            })

            api.propertyTariff(newValue).then(response => {
                that.dualTariff = response.data.data.d;
                that.electricityTariff = response.data.data.e;
                that.gasTariff = response.data.data.g;
            })
            
            
        }
    },
    mounted() {
        let that = this;
        api.properties().then(response => {
            that.properties = response.data.data;
            if(that.properties.length && !that.$route.params.property){
                that.selectedProperty = that.properties[0].id
            }
        })
        
        if(this.$store.getters['setup/isDataEmpty']) {
            api.survey().then(response => {
                this.$store.commit('setup/setData', response.data.data)
            });
        }
        
        if(this.$route.params.property){
            this.selectedProperty = this.$route.params.property
            this.$nextTick(function (){
                let elm = window.document.getElementById('propertySupplyDetails')
                if(elm){
                    elm.scrollIntoView()
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
@import "../../sass/base";

.text-gray {
    color: $gray-600;
    
}

.tariff-summary {
    p {
        margin: 0;
    }
    
}
</style>
